import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';
import type { HotlinePageData } from '../../modules/algebra/global';
import DOMPurify from 'dompurify';

const TOSMoreInfo: FC<{ pageData: HotlinePageData }> = ({ pageData }) => {
  const { moreInfo } = pageData;
  return (
    <div className="hotline-more-info">
      {moreInfo?.length > 0 && (
        <>
          <Typography variant="h2" className="w-full text-3xl px-24 text-center pt-6 pb-8 font-bold border-tc-7  border-t">
            More Information
          </Typography>
          <div className="grid grid-row-3 md:grid-cols-1 lg:grid-cols-3  flex w-full md:w-10/12 md:m-auto border-t py-5">
            {moreInfo?.map((info, index) => {
              return (
                <Paper className="px-4 xl:px-8 min-h-48 md:min-h-72 xl:min-h-56 2xl:min-h-48 relative shadow-none py-4" elevation={index}>
                  <Link href={info.titleLink} className="pt-5 pb-8 text-xl font-bold text-pc-1">
                    {info?.title}
                  </Link>
                  <Typography variant="body1" className="py-6 more-info-body" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(info?.content) }}></Typography>
                  {info?.linkTitle && (
                    <Link href={info?.link} className="read-more">
                      {info?.linkTitle}
                    </Link>
                  )}
                </Paper>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default TOSMoreInfo;
